import React from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
type FilterOption = {
  value: string;
  label: string;
};
type Props = {
  options: Array<FilterOption>;
  selectedValue?: string | null;
  onChange: (value: string | null) => void;
  additionalClassNames?: string;
  dataTestId?: string;
};
export const TabLikeFilters = ({
  options,
  selectedValue = null,
  onChange,
  additionalClassNames,
  dataTestId,
}: Props) => {
  const handleClick = (value: string) => {
    if (selectedValue === value) {
      onChange(null);
    } else {
      onChange(value);
    }
  };

  return (
    <div
      className={classnames('flex flex-wrap', additionalClassNames)}
      data-testid={dataTestId}
      role="group"
    >
      {options.map((option) => {
        const isActive = selectedValue === option.value;
        return (
          <div key={option.value} className="w-full p-10 md:w-1/2">
            <button
              type="button"
              onClick={() => handleClick(option.value)}
              className={classnames(
                'font-medium duration-200 w-full rounded-24 px-15 py-10 text-14 transition-all',
                'focus:ring-2 focus:ring-black focus:ring-offset-2 border border-black focus:outline-none',
                {
                  'bg-black text-white': isActive,
                  'hover:bg-gray-50 bg-white text-black': !isActive,
                },
              )}
              data-testid={dataTestId ? `${dataTestId}-${option.value}` : undefined}
              aria-pressed={isActive}
            >
              {option.label}
            </button>
          </div>
        );
      })}
    </div>
  );
};
